export default __webpack_public_path__ + "static/media/ElenaSoloveva.92b76606.pdf";